import {Component, OnInit} from "@angular/core";
import {ListView, TypeComparaison, TypeFilter} from "@domain/common/list-view";
import {Sorting} from "@domain/common/list-view/sorting";
import {TranslateService} from "@ngx-translate/core";
import {AnalytiqueAxe5ItemComponent} from "@components/admin/entreprise/analytique/axe5/analytique-axe5-item/analytique-axe5-item.component";
import {Axe5DTO} from "@domain/admin/entreprise/analytique/axe5Dto";
import {Router} from "@angular/router";
import {FloatingButtonAction, TypeAction} from "@share/component/floating-button/floating-button";
import {BehaviorSubject} from "rxjs";

/**
 * Composant d'affichage de la liste des référentiels Axe 5
 */
@Component({
	host: {'data-test-id': 'analytique-axe5'},
	selector: 'analytique-axe5',
	templateUrl: './analytique-axe5.component.html'
})
export class AnalytiqueAxe5Component implements OnInit {
	/** Liste des référentiels Axe 5 */
	listeAxe5: ListView<Axe5DTO,AnalytiqueAxe5ItemComponent>;

	/** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

	/**
	 * Constructeur
	 *
	 * @param translateService le service de traduction
	 * @param router le routeur Angular
	 */
	constructor(
		private translateService: TranslateService,
		private router: Router,
	) {
	}

	/**
	 * Initialisation du composant
	 */
	ngOnInit() {
		//Création de la liste des référentiels
		this.listeAxe5 = new ListView<Axe5DTO,AnalytiqueAxe5ItemComponent>({
			uri: `/controller/Analytique/getListeAxe5Result`,
			title: this.translateService.instant('admin.entreprise.analytique.axe5.title'),
			component: AnalytiqueAxe5ItemComponent,
			isFilter: true,
			defaultOrder: 'reference',
			listeFilters: [
				{
					clef: 'libelle',
					title: this.translateService.instant('admin.entreprise.analytique.axe5.libelle'),
					typeComparaison: TypeComparaison[TypeComparaison.LIKE],
					isDefault: true
				},{
					clef: 'reference',
					title: this.translateService.instant('admin.entreprise.analytique.axe5.reference'),
					typeComparaison: TypeComparaison[TypeComparaison.LIKE],
					isDefault: true
				},{
					clef: 'code1',
					title: this.translateService.instant('admin.entreprise.analytique.axe5.code1'),
					typeComparaison: TypeComparaison[TypeComparaison.LIKE],
					isDefault: true,
				},{
					clef: 'code2',
					title: this.translateService.instant('admin.entreprise.analytique.axe5.code2'),
					typeComparaison: TypeComparaison[TypeComparaison.LIKE],
					isDefault: true,
				},{
					clef: 'dateDebut',
					title: this.translateService.instant('admin.entreprise.analytique.axe5.dateOuverture'),
					isDefault: true,
					type: TypeFilter[TypeFilter.DATE],
					typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
				},{
					clef: 'dateFin',
					title: this.translateService.instant('admin.entreprise.analytique.axe5.dateFermeture'),
					isDefault: true,
					type: TypeFilter[TypeFilter.DATE],
					typeComparaison: TypeComparaison[TypeComparaison.EQUAL],
				}
			]
		});

		//Définition des colonnes de tri
		this.listeAxe5.columns = [
			{key: 'reference',title: 'admin.entreprise.analytique.axe5.reference'},
			{key: 'code1',title: 'admin.entreprise.analytique.axe5.code1'},
			{key: 'code2',title: 'admin.entreprise.analytique.axe5.code2'},
			{key: 'dateDebut',title: 'admin.entreprise.analytique.axe5.dateOuverture'},
			{key: 'dateFin',title: 'admin.entreprise.analytique.axe5.dateFermeture'}
		];

		//Ajout du tri de la liste selon l'ordre voulu
		this.listeAxe5.sorting = new Sorting(this.listeAxe5.columns,"reference");

		//Persistence des filtres
		this.listeAxe5.isPersistFilters = true;
		this.listeAxe5.className = 'AnalytiqueAxe5Component';

        //Initialisation des actions possibles
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-ajouter',
            libelle: 'global.actions.creer',
            doAction: () => this.create(),
        }]);
	}

	/**
	 * Méthode appelée lors de la création d'un nouveau service
	 */
	create() {
		this.router.navigate(['Admin/Entreprise/Analytique/Axe5/-1']);
	}
}
